module.exports = __webpack_public_path__ + "static/media/thumb.d52ad385.png";